import React, { useState } from 'react';

const PrayModal = ({ isOpen, onClose }) => {
  const [prayer, setPrayer] = useState('');
  const [step, setStep] = useState(1);
  const [copied, setCopied] = useState(false);

  const handleSubmit = async () => {
    // Enhanced prayer format with emojis and structure
    const formattedPrayer = `🙏 Prayer from a Believer 🕊️

"${prayer}"

✨ Join our blessed community:
@Hopefromthepope

#HFP #HopeFromThePope #Blessed #Faith #Prayer #Solana`;
    
    try {
      await navigator.clipboard.writeText(formattedPrayer);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
    
    setStep(2);
  };

  const goToPortal = () => {
    window.open('https://t.me/Hopefromthepope', '_blank');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="relative bg-gradient-to-b from-gray-900 to-black border border-yellow-400/20 rounded-2xl p-8 max-w-md w-full mx-4 transform transition-all duration-300 scale-100">
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-yellow-400 transition-colors"
        >
          ✕
        </button>

        {/* Content */}
        <div className="text-center space-y-6">
          {step === 1 ? (
            <>
              <span className="text-4xl animate-bounce inline-block">🙏</span>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
                Share Your Prayer
              </h2>
              
              <textarea 
                value={prayer}
                onChange={(e) => setPrayer(e.target.value)}
                placeholder="Type your prayer here... Share your hopes, wishes, and blessings."
                className="w-full h-32 bg-white/5 border border-yellow-400/20 rounded-xl p-4 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-400/50 focus:ring-1 focus:ring-yellow-400/50 transition-all resize-none"
              ></textarea>

              <div className="text-left text-sm text-gray-400 space-y-2">
                <p>Your prayer will be formatted with:</p>
                <ul className="list-disc list-inside space-y-1 pl-2">
                  <li>Beautiful emojis ✨</li>
                  <li>Community hashtags #HFP</li>
                  <li>Channel link @Hopefromthepope</li>
                </ul>
              </div>

              <button 
                onClick={handleSubmit}
                disabled={!prayer.trim()}
                className="w-full bg-[#229ED9] hover:bg-[#1E8BC3] disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-bold py-3 px-6 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
              >
                {copied ? (
                  <>
                    <span>Prayer Copied Successfully</span>
                    <span className="animate-bounce">✨</span>
                  </>
                ) : (
                  <>
                    <span>Format & Copy Prayer</span>
                    <span>📋</span>
                  </>
                )}
              </button>
            </>
          ) : (
            <>
              <span className="text-4xl animate-pulse inline-block">🕊️</span>
              <h2 className="text-2xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
                Join Our Blessed Community
              </h2>
              
              <div className="space-y-4 text-left">
                <p className="text-gray-300">Your blessed prayer has been copied! To share it:</p>
                <ol className="list-decimal list-inside space-y-2 text-gray-300">
                  <li>Click below to open our verification portal</li>
                  <li>Complete the quick verification process</li>
                  <li>Once verified, paste your prayer (Ctrl/Cmd + V)</li>
                  <li>Share your blessings with the community 🙏</li>
                </ol>
              </div>

              <button 
                onClick={goToPortal}
                className="w-full bg-[#229ED9] hover:bg-[#1E8BC3] text-white font-bold py-3 px-6 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18 1.897-.962 6.502-1.359 8.627-.168.9-.504 1.201-.825 1.23-.703.064-1.237-.461-1.917-.903-1.065-.692-1.665-1.122-2.7-1.799-.119-.084-.271-.127-.421-.127-.322 0-.636.161-.821.433-.205.301-2.051 2.242-2.051 2.242s-.234.227-.541.227c-.478 0-.863-.401-.863-.877 0-.163.045-.322.131-.461.831-1.344 4.159-6.708 4.159-6.708s.234-.379.234-.633c0-.355-.262-.645-.585-.645-.15 0-.295.056-.411.158L6.18 11.824c-.295.271-.678.421-1.078.421-.15 0-.301-.028-.444-.084-1.461-.571-2.819-1.196-2.819-1.196s-.384-.169-.384-.527c0-.355.355-.645.355-.645s4.386-1.897 7.095-2.951c1.163-.458 4.363-1.841 4.363-1.841s.384-.15.609-.15c.15 0 .301.028.444.084.234.113.384.355.384.618 0 .056-.006.113-.017.169z"/>
                </svg>
                Join Telegram Community
              </button>

              <p className="text-sm text-gray-400">
                Spread hope and faith with our growing community ✨
              </p>
            </>
          )}

          {/* Prayer Stats */}
          <div className="grid grid-cols-3 gap-4 pt-4 border-t border-yellow-400/20">
            <div>
              <p className="text-yellow-400 font-bold">24h</p>
              <p className="text-sm text-gray-400">42 prayers</p>
            </div>
            <div>
              <p className="text-yellow-400 font-bold">7d</p>
              <p className="text-sm text-gray-400">180 prayers</p>
            </div>
            <div>
              <p className="text-yellow-400 font-bold">Total</p>
              <p className="text-sm text-gray-400">1,337</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrayModal; 